function initCookiePreferences() {
    document.body.addEventListener("click", function(event) {
        const button = event.target.closest("[data-coookie-preferences-trigger]");
        if (!button) {
            return;
        }

        if (typeof window?.privacyBanner?.showPreferences !== "function") {
            return;
        }

        window.privacyBanner.showPreferences();
    });
}

document.addEventListener("DOMContentLoaded", function() {
  initCookiePreferences();
});